import React from 'react';
import LazyLoad from 'react-lazyload';

function Sponsors() {
  return (
   <section className="relative" data-aos="zoom-y-out" id="sponsors">

      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div className="absolute inset-0 top-1/2 md:mt-24 lg:mt-0 bg-white pointer-events-none" aria-hidden="true"></div>
      <div className="absolute left-0 right-0 bottom-0 m-auto w-px p-px h-20 bg-300-200 transform translate-y-1/2"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2">Hosts & Sponsors</h2>
          </div>
          {/* Items */}
          <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-1 items-start md:max-w-2xl lg:max-w-none">
            {/* 1st item */}
              <div>
            <div className="relative transition duration-500 ease-in-out relative flex flex-row flex px-6 py-2 rounded-lg ring-2
            justify-center ring-offset-2 ring-offset-blue-800 ring-cyan-700 mt-5
            cursor-pointer p-6 bg-white rounded shadow-xl hover:shadow-lg hover:border-gray-200">
                <div className="item-center text-center hover:shadow-lg" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "https://www.qualcomm.com/"
                }}>
                    <span className="">Sponsored By</span>
                    <LazyLoad height={300}>
                    <img className="relative" src={require('../images/qualcomm.png').default}
                         width="350" height="300" alt="Testimonial 01" />
                    </LazyLoad>
                </div>
                <div className="w-4"></div>
                <div className="item-center text-center hover:shadow-lg" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "https://india.acm.org/"
                }}>
                    <span className="">Event By</span>
                    <LazyLoad height={20}>
                    <img className="relative" src={require('../images/acm_flat.png').default} width="220" height="20"
                         alt="Testimonial 01" /></LazyLoad>
                </div>
                <div className="w-4"></div>
                <div className="item-center text-center hover:shadow-lg" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "https://www.iitk.ac.in/"
                }}>
                    <span className="">Hosted By</span>
                    <LazyLoad height={300}>
                    <img className="relative" src={require('../images/iitk-full.png').default}
                         width="300" height="300" alt="Testimonial 01" />
                    </LazyLoad>
                </div>
            </div>
              </div>
            {/* 1st item */}
              <div className="flex flex-row grid md:grid-cols-2 gap-7 lg:grid-cols-2 items-start md:max-w-2xl lg:max-w-none">
                  <div
                      className="w-full transition duration-500 ease-in-out relative flex flex-col md:flex-row md:space-x-5
            space-y-3 md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto
            border border-white bg-white ring-4 ring-offset-2 ring-offset-sky-400 ring-sky-200 cursor-pointer" onClick={(e) => {
                      e.preventDefault();
                      window.location.href = 'https://in.linkedin.com/in/awanish-pandey-38865755'
                  }}>
                      <div className="bg-white grid place-items-center">
                          <img src={require('../images/awanish.jpg').default} alt="tailwind logo" className="rounded-xl w-28"/>
                      </div>
                      <div className="w-full bg-white flex flex-col space-y-2 p-3">
                          <div className="flex justify-between item-center">
                              <p className="text-xl font-bold leading-snug">Awanish Pandey</p>
                              {/*<span>*/}
                              {/*      <img className="rounded-full w-9 h-9 max-w-none" alt="A"*/}
                              {/*           src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg"/>*/}
                              {/*                  <div*/}
                              {/*                      className="bg-green-300 px-1 py-1 rounded-full text-xs font-bold text-gray-800 shadow-xl">*/}
                              {/*    {objs.affiliation}</div>*/}
                              {/*</span>*/}
                              <div className="relative rounded-full text-black font-semibold text-xs flex align-center items-center
                  cursor-pointer active:bg-gray-300 transition duration-300 ease">
                                  <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                       src={require(`../images/qcom.png`).default}/>
                                  <span className="flex items-center subpixel-antialiased px-2 py-2">
                      Qualcomm
                    </span>
                              </div>
                          </div>
                          <p className="text-gray-500 font-bold">Academic Coordinator</p>
                          <p className="text-gray-500">awanpand@qti.qualcomm.com</p>
                      </div>
                  </div>
                  <div
                      className="w-full transition duration-500 ease-in-out relative flex flex-col md:flex-row md:space-x-5
            space-y-3 md:space-y-0 rounded shadow-xl hover:shadow-lg hover:border-gray-200 p-3 max-w-xs md:max-w-3xl mx-auto
            border border-white bg-white ring-4 ring-offset-2 ring-offset-sky-400 ring-sky-200 cursor-pointer" onClick={(e) => {
                e.preventDefault();
                window.location.href = 'https://www.cse.iitk.ac.in/users/subhajit/'
                  }}>
                      <div className="md:w-1/3 bg-white grid place-items-center">
                          <img src={require('../images/subhajit.png').default} alt="tailwind logo" className="rounded-xl w-24"/>
                      </div>
                      <div className="w-full bg-white flex flex-col space-y-2 p-3">
                          <div className="flex justify-between item-center">
                              <p className="text-xl font-bold leading-snug">Subhajit Roy</p>
                              {/*<span>*/}
                              {/*      <img className="rounded-full w-9 h-9 max-w-none" alt="A"*/}
                              {/*           src="https://mdbootstrap.com/img/Photos/Avatars/avatar-6.jpg"/>*/}
                              {/*                  <div*/}
                              {/*                      className="bg-green-300 px-1 py-1 rounded-full text-xs font-bold text-gray-800 shadow-xl">*/}
                              {/*    {objs.affiliation}</div>*/}
                              {/*</span>*/}
                              <div className="relative rounded-full text-black font-semibold text-xs flex align-center items-center
                  cursor-pointer active:bg-gray-300 transition duration-300 ease">
                                  <img className="rounded-full w-7 h-7 max-w-none" alt="A"
                                       src={require(`../images/iitk-logo.png`).default}/>
                                  <span className="flex items-center subpixel-antialiased px-2 py-2">
                      IIT Kanpur
                    </span>
                              </div>
                          </div>
                          <p className="text-gray-500 font-bold">Academic Coordinator</p>
                          <p className="text-gray-500">subhajit@cse.iitk.ac.in</p>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Sponsors;
